// import { useLocation,useNavigate  } from "react-router-dom";

function callAPI({ url, method, body, loadingState, dataState, headers, need_admin_token }) {

  // const navigate = useNavigate();
  // console.log("============" , url, method , loadingState, dataState)

  let prod_url = "https://4iav7nkzgsu2jbpidrdt7seiri0lcfhk.lambda-url.ap-south-1.on.aws"
  let test_url = "https://axfejoaohifvgsef7smho3bdzq0egnhy.lambda-url.ap-south-1.on.aws/"

  // let baseURL = test_url
  let baseURL = prod_url

  let methodWithBody = {}
  methodWithBody["method"] = method
  // methodWithBody["mode"] = "cors"
  if (body != undefined) {
    methodWithBody["body"] = JSON.stringify(body)
  }
  let token = localStorage.getItem("token")

  if (need_admin_token) {
    if (localStorage.getItem("agency-token")) {
      token = localStorage.getItem("agency-token")

    }
  }

  methodWithBody["headers"] = headers || {}
  methodWithBody["headers"]["Authorization"] = token || localStorage.getItem("token")
  loadingState(true)

  fetch(`${baseURL}/${url}`, methodWithBody).then(
    response => {
      if (response.ok) {
        return response.json()
      }
      else {
        return response.json()
      }
    }).then(data => {
      if (data.code == "401" && data.message != "Invalid credentials") {
        if (url != "/list-agency-account") {
          window.location.href = "/login";
        }

      }
      dataState(data)
      loadingState(false)
    }

    )
}


export default callAPI;